
import { FontInfo } from "../FontInfo";

export class Josefin_Sans_100 extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 100;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,201,296,572,567,732,702,148,395,400,335,544,184,300,186,326,617,308,496,518,506,543,520,476,508,524,175,201,675,709,646,453,972,709,573,690,726,631,571,735,735,258,309,641,591,894,813,865,530,879,617,551,575,693,692,984,588,643,697,344,325,344,470,601,205,542,543,420,543,467,291,543,487,208,216,423,208,765,487,503,543,543,321,344,304,487,431,659,369,431,368,278,223,324,387]
    }
  ]
}


export class Josefin_Sans_200 extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 200;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,201,296,572,567,732,702,148,395,400,335,544,184,300,186,326,617,308,496,518,506,543,520,476,508,524,175,201,675,709,646,453,972,709,573,690,726,631,571,735,735,258,309,641,591,894,813,865,530,879,617,551,575,693,692,984,588,643,697,344,325,344,470,601,205,542,543,420,543,467,291,543,487,208,216,423,208,765,487,503,543,543,321,344,304,487,431,659,369,431,368,278,223,324,387]
    }
  ]
}


export class Josefin_Sans_300 extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 300;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 307,201,312,574,567,750,711,154,398,402,335,546,201,302,165,348,619,315,507,520,518,527,529,476,514,529,176,202,647,712,625,455,993,706,590,691,736,639,578,741,752,275,330,655,603,906,822,862,554,882,633,581,577,707,702,993,620,661,703,351,349,351,472,603,231,559,562,433,562,487,324,564,512,225,224,451,225,787,512,519,562,562,342,368,325,509,454,665,405,454,404,306,242,341,402]
    }
  ]
}


export class Josefin_Sans_400 extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 400;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 316,201,339,578,567,780,725,164,403,405,335,550,203,304,168,384,623,329,545,523,535,523,545,489,523,537,177,203,601,717,590,459,1027,701,618,694,753,652,589,751,780,305,365,679,622,927,837,857,595,887,659,582,581,731,719,1008,672,691,712,362,389,362,475,607,274,586,593,456,593,520,379,598,553,254,259,498,254,825,553,545,593,593,376,407,359,546,494,674,465,494,463,353,274,371,426]
    }
  ]
}


export class Josefin_Sans_500 extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 500;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 316,201,339,578,567,780,725,164,403,405,335,550,203,304,168,384,623,329,545,523,535,523,545,489,523,537,177,203,601,717,590,459,1027,701,618,694,753,652,589,751,780,305,365,679,622,927,837,857,595,887,659,582,581,731,719,1008,672,691,712,362,389,362,475,607,274,586,593,456,593,520,379,598,553,254,259,498,254,825,553,545,593,593,376,407,359,546,494,674,465,494,463,353,274,371,426]
    }
  ]
}


export class Josefin_Sans_600 extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 600;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 320,202,350,580,567,792,731,169,405,406,335,552,204,305,170,399,625,335,560,525,542,521,551,495,527,541,178,204,583,719,576,461,1041,699,630,695,760,658,593,756,792,317,379,689,630,935,844,855,611,890,670,582,583,741,726,1014,693,704,716,367,406,367,477,609,291,597,605,465,605,533,402,612,569,266,274,517,266,840,569,555,605,605,390,423,373,561,510,678,490,510,487,372,287,383,436]
    }
  ]
}


export class Josefin_Sans_700 extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 700;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 325,202,366,582,567,810,740,175,408,408,335,554,205,306,172,421,628,344,583,527,553,518,561,503,532,546,179,205,555,722,555,464,1061,696,647,697,771,666,600,762,809,335,400,704,641,948,853,852,636,893,686,583,586,756,736,1023,725,722,722,374,430,374,479,612,317,614,624,479,624,553,435,633,594,284,295,546,284,863,594,571,624,624,410,447,394,584,534,684,526,534,522,401,306,401,451]
    }
  ]
}


export class Josefin_Sans_100_italic extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 100;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,199,296,572,568,758,701,148,324,324,335,544,200,300,163,326,619,310,537,511,505,542,521,468,512,525,175,201,675,709,646,452,963,709,577,697,731,631,571,740,736,258,310,641,561,896,813,869,530,903,617,546,575,695,691,983,586,643,631,352,325,393,470,601,200,545,544,423,547,470,291,546,487,208,226,423,208,766,487,502,543,544,321,346,304,487,431,659,359,422,368,277,257,323,487]
    }
  ]
}


export class Josefin_Sans_200_italic extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 200;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,199,296,572,568,758,701,148,324,324,335,544,200,300,163,326,619,310,537,511,505,542,521,468,512,525,175,201,675,709,646,452,963,709,577,697,731,631,571,740,736,258,310,641,561,896,813,869,530,903,617,546,575,695,691,983,586,643,631,352,325,393,470,601,200,545,544,423,547,470,291,546,487,208,226,423,208,766,487,502,543,544,321,346,304,487,431,659,359,422,368,277,257,323,487]
    }
  ]
}


export class Josefin_Sans_300_italic extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 300;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,200,312,574,572,779,705,154,344,344,335,546,201,302,164,348,628,326,549,493,509,528,536,476,526,536,176,202,647,712,625,450,982,706,590,697,738,639,578,746,753,278,332,655,578,909,824,865,550,939,633,543,577,717,694,985,608,661,641,352,349,385,472,603,201,561,564,436,564,488,324,565,512,225,236,451,226,788,512,519,558,559,343,369,325,509,455,666,396,449,404,302,269,335,479]
    }
  ]
}


export class Josefin_Sans_400_italic extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 400;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,201,339,578,579,814,712,164,376,376,335,550,203,304,165,384,642,349,567,503,515,522,561,489,549,554,177,203,601,717,591,447,1017,701,614,698,752,653,589,759,781,309,368,678,608,928,838,859,584,942,660,565,581,752,719,1008,644,691,658,351,389,371,475,607,203,589,595,460,595,521,380,600,553,254,266,499,255,826,553,546,585,588,378,408,359,546,494,675,456,494,463,343,287,355,465]
    }
  ]
}


export class Josefin_Sans_500_italic extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 500;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,201,339,578,579,814,712,164,376,376,335,550,203,304,165,384,642,349,567,503,515,522,561,489,549,554,177,203,601,717,591,447,1017,701,614,698,752,653,589,759,781,309,368,678,608,928,838,859,584,942,660,565,581,752,719,1008,644,691,658,351,389,371,475,607,203,589,595,460,595,521,380,600,553,254,266,499,255,826,553,546,585,588,378,408,359,546,494,675,456,494,463,343,287,355,465]
    }
  ]
}


export class Josefin_Sans_600_italic extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 600;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,201,350,580,582,829,715,169,389,389,335,552,204,305,166,399,648,359,575,507,518,519,571,495,559,562,178,204,583,719,577,446,1031,699,624,699,758,659,593,764,793,322,382,687,620,936,844,856,598,943,671,574,583,766,729,1017,659,704,665,351,406,365,477,609,204,601,607,470,607,535,402,615,570,266,279,518,267,841,570,557,596,600,393,424,373,561,510,679,481,513,487,359,295,363,459]
    }
  ]
}


export class Josefin_Sans_700_italic extends FontInfo
{
  fontName = "Josefin Sans";
  weight   = 700;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,202,366,582,587,850,720,175,409,409,335,554,205,306,167,421,657,373,586,513,522,515,586,503,573,573,179,205,555,722,556,444,1052,696,638,700,767,667,600,772,810,341,404,701,638,948,853,852,618,945,687,587,586,787,744,1031,681,722,676,350,430,357,479,612,205,618,626,485,626,555,436,636,595,284,297,547,285,864,595,573,612,617,414,448,394,584,534,684,517,540,522,384,306,375,451]
    }
  ]
}


export class JosefinSans
{
  static readonly fonts = [ new Josefin_Sans_100(), new Josefin_Sans_200(), new Josefin_Sans_300(), new Josefin_Sans_400(), new Josefin_Sans_500(), new Josefin_Sans_600(), new Josefin_Sans_700(), new Josefin_Sans_100_italic(), new Josefin_Sans_200_italic(), new Josefin_Sans_300_italic(), new Josefin_Sans_400_italic(), new Josefin_Sans_500_italic(), new Josefin_Sans_600_italic(), new Josefin_Sans_700_italic() ];
}

